
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


@Component
class Input2PasswordInput extends Vue {
  @Prop({ default: '' }) passwordValue?: string
  @Prop({ default: 'Password' }) passwordInputLabel?: string
  @Prop({ default: () => [] }) rules?: any[]

  isVisiblePassword: boolean = false

  set passwordValueVModel (value: string) {
    this.emitPasswordValue(value)
  }

  get passwordValueVModel (): string {
    return this.passwordValue || ''
  }

  toggleShowPassword () {
    this.isVisiblePassword = !this.isVisiblePassword
  }

  emitPasswordValue (value: string) {
    this.$emit('passwordValue', value)
  }
}

export default Input2PasswordInput

